// extracted by mini-css-extract-plugin
export default {"viewAllProjects":"ProjectListSideNavButtons_viewAllProjects__mctgz","menuNavigationWrapper":"ProjectListSideNavButtons_menuNavigationWrapper__YQPrw"};